export interface ModelPrice {
  inputUsdPerMillion?: number;
  outputUsdPerMillion?: number;
  cachedInputUsdPerMillion?: number;
}

export interface RuntimeModel {
  id: string;
  label: string;
  group: string;
  provider: string;
  price: ModelPrice;
  reasoning: string;
  context: number;
  available: boolean;
  availabilityReason?: string;
  healthState?: string;
  latencyMs?: number | null;
}

interface ModelCatalogResponse { models?: RuntimeModel[] }

export async function loadModelCatalog(gatewayUrl: string): Promise<RuntimeModel[]> {
  if (!gatewayUrl) return [];
  const response = await fetch(`${gatewayUrl.replace(/\/$/, "")}/v1/models`, { headers: { accept: "application/json" } });
  if (!response.ok) throw new Error(`โหลดรายการโมเดลไม่สำเร็จ (${response.status})`);
  const value = await response.json() as ModelCatalogResponse;
  return Array.isArray(value.models) ? value.models.filter((model) => model && typeof model.id === "string") : [];
}
